import { ServiceResponse } from '@nx-smartmonkey/shared/hooks';
import { useQuery } from '@tanstack/react-query';

import { sessionService } from '../../../application/SessionService';
import { useShowSnackbarMessage } from '../../../hooks/useShowSnackbarMessage';

interface UseSessionMagicLinkProps {
  vehicleId: string;
  routeId: string;
}

type UseSessionMagicLinkResponseProps = ServiceResponse<Function, string>;

export const useSessionMagicLink = ({
  vehicleId,
  routeId,
}: UseSessionMagicLinkProps): UseSessionMagicLinkResponseProps => {
  const { showSnackbarMessage } = useShowSnackbarMessage();

  const {
    isInitialLoading: isLoading,
    isRefetching,
    isError,
    isSuccess,
    refetch,
    data,
  } = useQuery(
    [`drivers_session_magic_link`, vehicleId, routeId],
    () => sessionService.createSessionMagicLink({ vehicleId, routeId }),
    {
      enabled: false,
      refetchOnWindowFocus: false,
      retry: false,
      onError: (err: any) => {
        console.info(`Vehicle Session Login MagicLink Error: `, err?.response);

        if (err?.response?.status === 401) {
          showSnackbarMessage({
            messageIntlId: `infoerror.drivers.magic_link.error`,
          });
        }
      },
    }
  );

  return {
    error: isError,
    success: isSuccess,
    isLoading: isLoading || isRefetching,
    data: data,
    run: refetch,
  };
};
